<template>
  <div class="container wc-container wc-container-720">
    <div class="landing-page">
      <div class="actions-header">
        <Button type="success" @click="save">Save</Button>
        <Button type="default">Publish</Button>
      </div>

      <div class="content">
        <vue-editor
          :useCustomImageHandler="true"
          @imageAdded="handleImageAdded"
          v-model="data.html"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import $config from "@/config";
import axios from "axios";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      data: {
        webcastId: null,
        html: ""
      },
      apiData: []
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    })
  },
  methods: {
    ...mapActions("landing-content", {
      getLandingContent: "find",
      createLandingContent: "create",
      updateLandingContent: "update"
    }),

    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post($config.uploadServer, formData)
        .then(result => {
          let url = result.data;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
    },

    setHtmlFromApi(data) {
      this.$set(this.data, "html", data);
    },

    save() {
      if (this.apiData.length) {
        this.updateLandingContent([this.apiData[0]["_id"], this.data]);
      } else {
        this.createLandingContent(this.data);
      }
    }
  },

  created() {
    this.$data.data.webcastId = this.webcast._id;
    this.getLandingContent({
      query: {
        webcastId: this.webcast._id
      }
    }).then(res => {
      this.apiData = res.data;

      if (this.apiData.length) {
        this.setHtmlFromApi(this.apiData[0].html);
      }
      console.log("apiData", this.apiData);
    });
  },

  components: {
    VueEditor
  }
};
</script>

<style lang="scss" scoped>
.actions-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 25px 0;
}
</style>